"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (value, pips) {
    return +value.toFixed(pips).slice(-1);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/number/getLastDigit.js
// module id = 26
// module chunks = 0